import { ISODateString } from "@smartrr/shared/entities/ISODateString";
import { SubscriptionContractSubscriptionStatus } from "@smartrr/shared/shopifyGraphQL/api";
import { groupAndSortByDate } from "@smartrr/shared/utils/groupAndSortByDate";
import flatten from 'lodash/flatten';
import { useMemo } from "react";

import { usePurchaseStates } from "../usePurchaseStates";

// Purchase states excluding skipped subscriptions
export const useSortedPurchaseStates = () => {
  const purchaseStates = usePurchaseStates();

  return useMemo(() => {
    return groupAndSortByDate(
      flatten(
        purchaseStates
          .filter(
            cps =>
              cps.purchaseStateStatus === SubscriptionContractSubscriptionStatus.Active ||
              cps.purchaseStateStatus === SubscriptionContractSubscriptionStatus.Paused
          )
          .sort((a, b) => {
            return a.purchaseStateStatus === SubscriptionContractSubscriptionStatus.Active &&
              b.purchaseStateStatus !== SubscriptionContractSubscriptionStatus.Active
              ? -1
              : 1;
          })
      ),
      cps => ISODateString.fromString(cps.createdDate).toJSDate(),
      "DESC"
    );
  }, [purchaseStates]);
};
